module.exports = __webpack_public_path__ + "static/media/bill1.45c6bf6c.png";